import CreateSetupBackend from "../config/config.js";
import utilService from "./utilService.js";

let SetupBackend = null;

function adminCheck(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get(
    `/v1/subusersaccountmanager/subuseradmin/${data.email}`
  );
}

function createUser(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post("/v1/subusersaccountmanager/subusercreate", data);
}

function updateUser(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.put("/v1/subusersaccountmanager/subuserupdate", data);
}

async function indexUsers(data) {
  await utilService.getJWT();
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get(
    `/v1/subusersaccountmanager/subuserindex/${data.email}`
  );
}

function destroyUser(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.delete(
    `/v1/subusersaccountmanager/destroy/${data.email}`
  );
}

const backendServices = {
  adminCheck,
  createUser,
  updateUser,
  indexUsers,
  destroyUser,
};

export default backendServices;
